<template>
  <van-tabbar v-model="active" class="tab-bar" fixed placeholder active-color="#D82D2C" inactive-color="#7C8AA2">
    <van-tabbar-item to="home">
      <template #icon="{ active: isActive }">
        <SvgIcon name="tabbar/home" :size="35" :color="isActive ? '#D82D2C' : '#7C8AA2'" />
      </template>
      Home
    </van-tabbar-item>
    <van-tabbar-item to="matches">
      <template #icon="{ active: isActive }">
        <SvgIcon name="tabbar/myMatches" :size="35" :color="isActive ? '#D82D2C' : '#7C8AA2'" />
      </template>
      My Matches
    </van-tabbar-item>
    <van-tabbar-item to="rewards">
      <template #icon="{ active: isActive }">
        <SvgIcon name="tabbar/rewards" :size="35" :color="isActive ? '#D82D2C' : '#7C8AA2'" />
      </template>
      Rewards
    </van-tabbar-item>
  </van-tabbar>
</template>

<script setup>
import { ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import SvgIcon from '@/components/SvgIcon/index.vue'

const route = useRoute()
const active = ref(0)

const routeMap = {
  'Home': 0,
  'Matches': 1,
  'Rewards': 2,
}

watch(
  () => route.name,
  (name) => {
    active.value = routeMap[name] ?? 0
  },
  { immediate: true }
)
</script>

<style scoped lang="less">
.tab-bar {
  --van-tabbar-height: 52px;
  --van-tabbar-item-active-color: #D82D2C;
  --van-tabbar-item-text-color: #7C8AA2;
}
</style>
<style lang="less">
.van-tabbar {
  max-width: 375px;
  margin: 0 auto;
}

.tab-bar {
  .van-tabbar-item__icon {
    max-width: 35px !important;
    max-height: 35px !important;
    min-width: 35px !important;
    min-height: 35px !important;
    overflow: hidden;
    display: flex;
    align-items: center;
    margin-bottom: 0px !important;
    justify-content: center;
  }

  .van-tabbar-item__text {
    margin-top: -2px !important;
  }
}
</style>
